import api from '../../../utils/api';
import { StoredFileMetadata } from '../../shared/types';

export interface FindAdditionalInformationResponse {
    additionalComments?: string;
    landlordsStatement?: StoredFileMetadata[];
    extraDocuments?: StoredFileMetadata[];
}

const findAdditionalInformation = async (homeseekerId: string): Promise<FindAdditionalInformationResponse> => {
    return await api.getWithoutAuth(`api/screening/${homeseekerId}/additional-information/get`);
}

export default findAdditionalInformation;
